// @ts-check
/* global Tygh $ module require*/
'use_strict';

/**
 * UI object to update the displayed stock stats in the product heading.
 *
 * @property {Element} element containing the stock status.
 * @property {string} suffix of the js-config-out-of-stock element for when it's loaded in a modal.
 */
export class StockStatus {

    /**
     * @var {HTMLElement} element is the In Stock Info element.
     * @var {string} suffix of the js-config-out-of-stock element for when it's loaded in a modal.
     */
    element: HTMLElement;
    suffix: string;

    /**
     * Bind to the element and do the initial update.
     *
     * @param {number} product_id needed as the native 'in_stock_info' elements suffix.
     * @param {string} suffix of the js-config-out-of-stock element for when it's loaded in a modal.
     */
    constructor(product_id, suffix) {
        this.element = document.getElementById('in_stock_info_' + product_id);
        this.suffix = suffix;
        this.update();
    }

    /**
     * Parse the config response to see if there is an out of stock warning, and hide the instock check box if there is.
     *
     * @public
     * @returns {void}
     */
    update() {
        // If there is no in stock element, just return.
        if (!this.element) {
            return;
        }

        const status = JSON.parse((<HTMLInputElement> document.getElementById('js-config-out-of-stock' + this.suffix)).value);
        if (status.length > 0) {
            this.element.style.display = 'none';
        } else {
            this.element.style.display = 'block';
        }
    }
}
